/* eslint-disable no-empty */
/* global G */
import settings from '@tenant/settings'

/**
 * Executes the `pluginsAdapter` `login` method.
 *
 * @param {Gaia.AppModule.Spec} module the platform Application
 * @returns {function(*): Promise<*>}
 */
export const pluginsLogin = module => async (args) => {
  const session = module[G.ADAPTER][G.SESSION][G.STATE][G.META]
  const pluginsAdapter = module[G.ADAPTER][G.PLUGIN]
  session && await pluginsAdapter.login()
  return args
}

/**
 * Initializes the application plugins defined in tenant's settings. If there is a logged-in user,
 * it also calls the login lifecycle method of the plugins-adapter.
 *
 * @returns {function(*): Promise<*>}
 */
const init = obj => async (args) => {
  const pluginsAdapter = obj[G.ADAPTER][G.PLUGIN][G.API]
  await pluginsAdapter.init(settings.plugins || [])

  if (obj[G.SESSION][G.STATE][G.META]) {
    await pluginsAdapter.login()
  }

  return args
}

export default init
